import { ChangeDetectorRef, Output, EventEmitter } from '@angular/core';
import { Focusable } from './../../interfaces/focusable';
import { NgbDateSrParserFormatter } from './../date-picker-popup/ngb-date-sr-parser-formatter';
import { Component, OnInit, Input, ViewChild, ElementRef, HostListener } from '@angular/core';
import { AbstractCustomControl, MakeProvider } from '../abstract-custom-control';
import { NgbDate, NgbDateParserFormatter, NgbDatepicker } from '@ng-bootstrap/ng-bootstrap';
import { UserService } from '../../base-services/user.service';
import { ConfirmationDialogButtons } from '../confirmation-dialog/confirmation-dialog-buttons';
import { ModalService } from '../../base-services/modal.service';
//import { defaultStyleSanitizer } from '@angular/core/src/sanitization/sanitization';

@Component({
  selector: 'yt-fw-date-picker-popup',
  templateUrl: './date-picker-popup.component.html',
  //styleUrls: ['./date-picker-popup2.component.scss']
  providers: [
    MakeProvider(DatePickerPopup2Component),
    { provide: NgbDateParserFormatter, useClass: NgbDateSrParserFormatter}
  ]
})
export class DatePickerPopup2Component extends AbstractCustomControl<any> implements Focusable, OnInit {

  constructor(protected changeDetectorRef: ChangeDetectorRef,
              protected userService: UserService,
              protected modalService: ModalService,
              protected ngbDateParserFormatter: NgbDateParserFormatter) {
    super(changeDetectorRef);
  }

  //@Input() Placeholder: string;

  @ViewChild('inputControl', { static: true }) inputControl: ElementRef
  @ViewChild('placeholder', { static: true }) placeholder: ElementRef
  @ViewChild('errorIcon', { static: true }) errorIcon: ElementRef;
  @ViewChild('toggleButton', { static: true }) toggleButton: ElementRef;
  @ViewChild('clearButton', { static: false }) clearButton: ElementRef;
  @ViewChild('d', { static: true }) datePicker: any;

  @Input() MinDate: NgbDate = new NgbDate(1900, 1, 1);
  @Input() MaxDate: NgbDate = new NgbDate(2999, 12, 31);
  
  // disablovanje kontrole ali omogucavanje da se kalendar koristi i menja vrednosti.
  @Input() readonly: boolean = false;
  @Output() OnDateSelected = new EventEmitter();

  private today = new Date();
  private allowedKeyCodes: number[] = [
    48, 49, 50, 51, 52, 53, 54, 55, 56, 57,
    96, 97, 98, 99, 100, 101, 102, 103, 104, 105,

    //backspace
    8,

    //arrows
    37, 39,

    //tab
    9,

    //delete
    46,

    //home
    36,

    //end
    35,

    //down
    40
  ]

  ngOnInit() {
    //this.allowedKeyCodes.push(this.userService.GetDateSeparator().charCodeAt(0));
  }

  ngAfterViewInit(){
    this.setSize();
  }

  // @HostListener('window:resize', ['$event'])
  // onResize(event){
  //   //this.setSize();
  // }

  focus(){
    this.inputControl.nativeElement.focus();
  }

  Clear(){
    this.value = null;
  }

  setSize(){
    if(this.inputControl.nativeElement.offsetWidth > 0){
      this.placeholder.nativeElement.style.width = this.inputControl.nativeElement.offsetWidth + 'px';
      this.errorIcon.nativeElement.style.left = this.inputControl.nativeElement.offsetWidth - 5 + 'px';
    }
  }

  isToday(date: NgbDate){
    return date.day == this.today.getDate() && date.month == this.today.getMonth() + 1 && date.year == this.today.getFullYear();
  }

  setDisabledState(isDisabled: boolean){
    super.setDisabledState(isDisabled);
    this.inputControl.nativeElement.disabled = isDisabled;
    this.toggleButton.nativeElement.disabled = isDisabled;
    //this.clearButton.nativeElement.disabled = isDisabled;
  }

  onKeydown(event){
    //if((event.keyCode < 48 || event.keyCode > 57) && event.keyCode != 8 && event.keyCode != 110 && event.keyCode != 190 && event.keyCode != 111 && event.keyCode != 191 && event.keyCode != 9)
    if(event.keyCode == 40){
      this.datePicker.open();
    }
    else if(this.allowedKeyCodes.indexOf(event.keyCode) == -1 && event.key != this.userService.GetDateSeparator())
    {
      
        event.stopPropagation();
        event.preventDefault();
        return;
     }
     else{
       this.datePicker.close();
     }

      //let regexp = new RegExp('^[1-9]{2}(.|/)[0-9]{2}(.|/)[0-9]{4}$');
      //if(!regexp.test(this.value))
        //event.preventDefault();
  }

  dateChanged(value){
    if((!value.after(this.MinDate) || !value.before(this.MaxDate)) && (!value.equals(this.MinDate) && !value.equals(this.MaxDate))){
      this.value = this._oldValue;
      alert('Datum van opsega.' + 'Min: ' + this.MinDate.day + '/' + this.MinDate.month + '/' + this.MinDate.year + '. Max: ' + this.MaxDate.day + '/' + this.MaxDate.month + '/' + this.MaxDate.year);
      return;
    }
      this.OnDateSelected.emit(value);
  }

  writeValue(value){
    super.writeValue(value);
    this.OnDateSelected.emit(value);
  }

  onBlur(event){
    //console.log(this.value);
    //if(this.value['day'] && this.value['month'] && this.value['year'])
    //if(this.value){
      //let valueArray = this.value.split(this.userService.GetDateSeparator());
      //if(valueArray.length == 3){
        //this.value = { day: parseInt(valueArray[0]), month: parseInt(valueArray[1]), year: parseInt(valueArray[2]) };
        //this.OnDateSelected.emit(this.value);
      //}
    //}
    if(this.value && this.value['day'] && this.value['month'] && this.value['year']
    && this.value['day'] > 0 && this.value['month'] > 0 && this.value['year'] > 1899){
      let date = new NgbDate(this.value["year"], this.value["month"], this.value["day"]);
      if((date.after(this.MinDate) || date.equals(this.MinDate)) && (date.before(this.MaxDate) || date.equals(this.MaxDate))){
        //if((this.value as NgbDate).after(this.MinDate) && this.value.before(this.MaxDate))
        this.OnDateSelected.emit(this.value);
      }
      else{
        alert('Datum van opsega.' + 'Min: ' + this.MinDate.day + '/' + this.MinDate.month + '/' + this.MinDate.year + '. Max: ' + this.MaxDate.day + '/' + this.MaxDate.month + '/' + this.MaxDate.year);
        this.value = null;
        this.inputControl.nativeElement.focus();
        return;
      }
    }
    else
      if(this.value && this.value.indexOf(this.userService.GetDateSeparator()) > -1 && this.value.split(this.userService.GetDateSeparator()).length == 3
      && this.value.split(this.userService.GetDateSeparator())[0] > 0 && this.value.split(this.userService.GetDateSeparator())[1] > 0 && this.value.split(this.userService.GetDateSeparator())[2] > 1900){
        let date = new Date(this.value);
        if(date instanceof Date && !isNaN(date.valueOf())){
          this.value = this.ngbDateParserFormatter.parse(this.value);
          this.OnDateSelected.emit(this.value);
        }
        else if(this.value != null){
          this.value = null;
          this.modalService.ShowConfirmationDialog(
            "Obaveštenje",
            "Datum nije u dobrom formatu. Primer ispravnog formata: 20.11.2024",
            "alert",
            ConfirmationDialogButtons.Ok
          );
          this.inputControl.nativeElement.focus();
          //event.preventDefault();
          //event.stopPropagation();
        }
      }
    else if(this.value != null){
      this.value = null;
      this.modalService.ShowConfirmationDialog(
        "Obaveštenje",
        "Datum nije u dobrom formatu. Primer ispravnog formata: 20.11.2024",
        "alert",
        ConfirmationDialogButtons.Ok
      );
      this.inputControl.nativeElement.focus();
      //event.preventDefault();
      //event.stopPropagation();
    }
  }

  toggle(d){
    d.toggle();
  }

  ResetMinMaxDate(){
    this.MinDate = new NgbDate(1900, 1, 1);
    this.MaxDate = new NgbDate(2999, 12, 31);
  }

}
